export const DEFAULT_MAX_TOKENS = 4096;
export const MIN_MAX_TOKENS = 256;
export const MAX_MAX_TOKENS = 32_768;

export const DEFAULT_EXTRACT_TIMEOUT_MS = 180_000;
export const MIN_EXTRACT_TIMEOUT_SECONDS = 30;
export const MAX_EXTRACT_TIMEOUT_SECONDS = 600;

export function parseMaxTokens(raw: string): number | null {
  const trimmed = raw.trim();
  if (!trimmed) {
    return DEFAULT_MAX_TOKENS;
  }
  if (!/^\d+$/.test(trimmed)) {
    return null;
  }
  const value = Number(trimmed);
  if (value < MIN_MAX_TOKENS || value > MAX_MAX_TOKENS) {
    return null;
  }
  return value;
}

export function parseReasoningEnabled(raw: string): boolean {
  return raw === "true" || raw === "on" || raw === "1";
}

/** UI seconds → milliseconds. Empty uses the default. */
export function parseExtractTimeoutSeconds(raw: string): number | null {
  const trimmed = raw.trim();
  if (!trimmed) {
    return DEFAULT_EXTRACT_TIMEOUT_MS;
  }
  if (!/^\d+$/.test(trimmed)) {
    return null;
  }
  const seconds = Number(trimmed);
  if (
    seconds < MIN_EXTRACT_TIMEOUT_SECONDS ||
    seconds > MAX_EXTRACT_TIMEOUT_SECONDS
  ) {
    return null;
  }
  return seconds * 1000;
}

export function resolveExtractModel(
  extractModel: string | null | undefined,
  chatModel: string,
): string {
  const trimmed = extractModel?.trim() ?? "";
  return trimmed.length > 0 ? trimmed : chatModel;
}
